export default {
    competencyMatrix: {
        title: 'Competency Report',
        subtitle: "An overview of the team's competencies by category",
        profiles: {
            all: 'All profiles',
        },
        highlights: {
            employees: 'Employees shown',
            employeesDescription: 'Team members visible in the matrix',
            toImprove: 'Top priority category',
            strongest: 'Strongest category',
            noData: 'No data available',
        },
        matrix: {
            title: 'Competency matrix by category',
            average: 'Average',
            expand: 'Expand the {{name}} group',
            collapse: 'Collapse the {{name}} group',
            previous: 'Previous employees',
            next: 'Next employees',
            openProfile: 'Open the performance profile for {{name}}',
            notAssessed: 'Not assessed',
        },
        legend: {
            title: 'Levels legend',
        },
        loadError: {
            title: 'Report could not be loaded',
            message:
                'The competency report is not responding. Reload the page or change the filters.',
        },
        empty: {
            title: 'No employees to display',
            message: 'No employees match the selected filters.',
        },
        truncated: 'This list is capped; {{count}} employees match these filters.',
        truncated_one: 'This list is capped; {{count}} employee matches these filters.',
        truncated_other: 'This list is capped; {{count}} employees match these filters.',
    },
    disabled: {
        title: 'Reports not enabled',
        message: 'Reports are not enabled for your organization.',
    },
};
